import { FC } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { Coupon as CouponModel } from '../../../models/membership/Coupon'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { selectCouponById } from '../../../store/membership/CouponReducer'

type Props = SBModelComponent<CouponModel> & {}

const CouponOption: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectCouponById(id!))

  if (!item) {
    return <></>
  }

  return item.name
}

type CouponOptionType = { Option: typeof CouponOption }

export { CouponOption, type CouponOptionType }
